/* eslint-disable max-params, no-param-reassign -- these linting errors come up constantly with reducers */
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { RootState } from "@/store";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { extraReducersFactory } from "@/store/reducers/reset";
import type { ToastRequest } from "@/ui/composed/toast/Toast";

interface ToastSliceState {
  orphanToastRequest?: ToastRequest;
}

const initialState: ToastSliceState = {
  orphanToastRequest: undefined,
};

const toastSlice = createSlice({
  // NOTE: extraReducers is required for resetAllReduxSlices to work as expected
  extraReducers: extraReducersFactory(initialState),
  initialState,
  name: "toast",
  reducers: {
    setOrphanToastRequest: (
      state,
      action: PayloadAction<ToastRequest | undefined>,
    ) => {
      state.orphanToastRequest = action.payload;
    },
  },
});

const { setOrphanToastRequest: setOrphanToastRequestAction } =
  toastSlice.actions;

const selectOrphanToastRequest = (state: RootState) =>
  state.toast.orphanToastRequest;

const useOrphanToastRequestSelector = () => {
  return useAppSelector(selectOrphanToastRequest);
};

const useToastDispatch = () => {
  const dispatch = useAppDispatch();

  const setOrphanToastRequest = (config: ToastRequest | undefined) => {
    dispatch(setOrphanToastRequestAction(config));
  };

  return {
    setOrphanToastRequest,
  };
};

export type { ToastSliceState };
export {
  setOrphanToastRequestAction,
  useOrphanToastRequestSelector,
  useToastDispatch,
};
export default toastSlice.reducer;
